import { createFileRoute, Navigate } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { ReportsDashboardView } from 'components/views/reports-dashboard-view';
import Loading from 'src/modules/shared/components/atoms/loading';
import { useHasPermissions } from 'src/modules/shared/hooks/auth';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';
import { ReportPermission } from 'src/modules/shared/types/permissions.type';
import { Route as CallsReportsRoute } from 'src/routes/calls.reports';

/**
 * Route entry for the widget-based reports dashboard page.
 */
export const Route = createFileRoute('/reports-panel/')({
  component: ReportsPanelIndexComponent,
  validateSearch: (search) =>
    globalSearchSchema
      .extend({
        phoneVersion: globalSearchSchema.shape.phoneVersion.default(
          'v1' as const
        ),
      })
      .parse(search),
});

function ReportsPanelIndexComponent() {
  const { hasPermission: canReadDashboard, loading } = useHasPermissions(
    ReportPermission.DashboardRead
  );

  if (loading) {
    return <Loading size="lg" />;
  }

  if (!canReadDashboard) {
    return (
      <Navigate
        to={CallsReportsRoute.to}
        search={{ phoneVersion: 'v1', tab: 'basic' }}
      />
    );
  }

  return (
    <AuthenticateRoute>
      <ReportsDashboardView />
    </AuthenticateRoute>
  );
}
